import React from 'react';
import { AppState } from 'src/AppState';
import { CompanyCheck } from 'src/easyclaim.app.components/common/CompanyCheck';
import { EasyClaimAppState, ValidationResult } from 'src/easyclaim.api.client.typescript/src';
import { FormattedMessage } from 'react-intl';
import { ChevronLeft } from 'src/easyclaim.app.assets/icons/ChevronLeft';

interface StepsProgressBarState {
	uploadedImageCount: number;
}

export class StepsProgressBar extends React.Component<AppState, StepsProgressBarState> {
	constructor(props: AppState) {
		super(props);
		this.state = {
			uploadedImageCount: this.getUploadedImageCount(),
		};
	}

	private getUploadedImageCount(): number {
		let uploadedImages = 0;
		var images = [
			this.props.dniOutside,
			this.props.dniInside,
			this.props.driverLicenseOutside,
			this.props.driverLicenseInside,
			this.props.vehicleDatasheetOutside,
			this.props.vehicleDatasheetInside,
			this.props.itv,
			this.props.dashboardImage,
			this.props.vinImage,
			this.props.overallDashboardImage,
			this.props.windshieldImage,
			this.props.vehicleImageFrontLeft,
			this.props.vehicleImageFrontRight,
			this.props.vehicleImageRearRight,
			this.props.vehicleImageRearLeft,
			this.props.vehicleImageFront,
			this.props.vehicleImageRear,
			this.props.vehicleImageLeft,
			this.props.vehicleImageRight,
			this.props.additionalDocumentImage,
		];
		if (CompanyCheck.isGPUProcess(this.props.easyClaimCase?._configuration?.companyShortName)) {
			images.push(this.props.registrationDocument);
			images.push(this.props.registrationDocument2);
		}
		if (
			!CompanyCheck.isUniqaPL(
				this.props.easyClaimCase?._configuration?.companyShortName?.toLocaleLowerCase().trim()
			)
		) {
			images.push(this.props.closeUpDamageImage);
			images.push(this.props.overallDamageImage);
		}

		images.forEach((image) => {
			const hasError =
				image?.uploadResult?.validationResults?.find(
					(vr) => vr.validationResult === ValidationResult.Error
				) !== undefined;
			if (image !== undefined && !hasError) {
				uploadedImages++;
			}
		});
		return uploadedImages;
	}

	componentDidUpdate() {
		let uploadedImages = this.getUploadedImageCount();
		if (this.state.uploadedImageCount !== uploadedImages) {
			this.setState({
				uploadedImageCount: uploadedImages,
			});
		}
	}

	render() {
		if (
			!this.props.screen ||
			!this.props.easyClaimCase ||
			!this.props.easyClaimCase._configuration ||
			!this.props.easyClaimCase._configuration.frontendSteps
		) {
			return null;
		}

		const frontendSteps = this.props.easyClaimCase._configuration.frontendSteps;
		var requiredPhotosCount = 0;

		frontendSteps.forEach((step) => {
			step.controlsConfigurations?.forEach((configuration) => {
				if (configuration.documentType !== undefined && configuration.isRequired) {
					requiredPhotosCount++;
				}
			});
			if (step.appState === EasyClaimAppState.VehicleInformation) {
				//this state do not have configuration for photos
				requiredPhotosCount = requiredPhotosCount + 2;
			}
		});

		const mappedTitle =
			this.props.screen.charAt(0).toLowerCase() + this.props.screen.slice(1) + '.title';

		return (
			<div className="menu-container-progress-container">
				<ChevronLeft />
				<h2>
					<FormattedMessage id={mappedTitle} />
				</h2>
				<span className="menu-container-progress-value">
					{this.state.uploadedImageCount} / {requiredPhotosCount}
				</span>
				<progress
					className="menu-container-progress-bar"
					value={this.state.uploadedImageCount}
					max={requiredPhotosCount}
				></progress>
			</div>
		);
	}
}
